import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { graphql, useStaticQuery } from 'gatsby'
import styled from 'styled-components'

import OuterLink from '../atoms/OuterLink'
import { Query } from '../graphqlTypes'

const Container = styled.div`
  margin: 12px 10px 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 20px 0 0;
  }
`

const Feed = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  list-style: none;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: normal;
  }
`

const Item = styled.li`
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  margin: 0 0 8px;
  padding: 8px 8px 16px;
  width: calc(50% - 1.5px);
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    border: 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
    border-radius: 0;
    box-shadow: none;
    box-sizing: border-box;
    margin: 0;
    padding: 10px;
    width: 100%;
    &:first-child {
      padding: 0 10px 10px;
    }
    &:last-child {
      border: 0;
      padding-bottom: 0;
    }
  }
`

const PostImage = styled.img`
  display: block;
  object-fit: cover;
  width: 100%;
  height: auto;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 10px auto 0;
  }
`

const Author = styled(OuterLink)`
  color: ${({ theme }) => theme.palette.font.link};
  display: block;
  font-size: 8px;
  font-weight: bold;
  margin: 10px 0 0;
  text-decoration: none;
`

const Text = styled.p`
  display: -webkit-box;
  margin: 5px 0 0;
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 10px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    -webkit-line-clamp: 2;
  }
`

export default function InstagramFeed({ className }: { className?: string }) {
  const { allInstagramPosts }: Query = useStaticQuery(graphql`
    query {
      allInstagramPosts(limit: 4, sort: { fields: [media_id], order: DESC }) {
        edges {
          node {
            id
            author_name
            author_url
            caption
            permalink
            thumbnail_url
          }
        }
      }
    }
  `)

  return (
    <Container className={className}>
      <Feed>
        {allInstagramPosts.edges.map(({ node }, index) => (
          <Item key={node.id}>
            <OuterLink to={node.permalink as string}>
              <LazyLoadComponent>
                <PostImage alt={`Instagram 投稿画像 ${index + 1}枚目`} src={`${node.permalink}media?size=t`} />
              </LazyLoadComponent>
            </OuterLink>
            <Author to={node.author_url as string}>@{node.author_name}</Author>
            <Text>{node.caption}</Text>
          </Item>
        ))}
      </Feed>
    </Container>
  )
}
